import type { ResourceMeta } from '@elara/core/agent/resources';

import type { FirestoreContainer } from '#containers/FirestoreContainer.js';
import type { ClientInstanceOf } from '#firebase/types.js';

import { ResourceMetadataSpec } from '@elara/domain/models/ResourceMetadataSpec';

import { createClientModel } from '#firebase/createClientModel.js';

const hasStructuredClone = typeof structuredClone === 'function';

function cloneMeta(meta: unknown): ResourceMeta {
  if (meta && typeof meta === 'object') {
    if (hasStructuredClone) return structuredClone(meta as ResourceMeta);
    return JSON.parse(JSON.stringify(meta)) as ResourceMeta;
  }
  return {} as ResourceMeta;
}

export function createResourceMetadataModel(firestore: FirestoreContainer) {
  const model = createClientModel(firestore, ResourceMetadataSpec, () => ({
    get resourceMeta(): ResourceMeta {
      const cloned = cloneMeta(this.meta);
      if (!cloned.id) cloned.id = this.resourceId ?? this.id;
      if (this.provider && !cloned.provider) cloned.provider = this.provider;
      if (this.resourceType && !cloned.resourceType) cloned.resourceType = this.resourceType;
      if (this.status && !cloned.status) cloned.status = this.status;
      if (this.toolCallId) cloned.toolCallId = this.toolCallId;
      if (this.agentId) {
        const metadata = { ...cloned.metadata, agentId: this.agentId };
        cloned.metadata = metadata;
      }
      return cloned;
    },
  }));

  return model;
}

export type ResourceMetadataModel = ReturnType<typeof createResourceMetadataModel>;
export type ResourceMetadata = ClientInstanceOf<ResourceMetadataModel>;
